import {ATTRIBUTE_SYSTEM_ID} from '@netx/core-attribute/constants';
import {SearchType} from './rules/constants';

export enum SearchMatchCriteria {
	AND = 0,
	OR = 1,
	NOT = 2,
}

export enum SearchSortOrder {
	ASC = 0,
	DESC = 1,
}

export const DEFAULT_SEARCH_SORT_FIELD = 'file';
export const DEFAULT_SEARCH_SORT_ORDER = SearchSortOrder.ASC;
export const DEFAULT_SEARCH_MATCH_CRITERIA = SearchMatchCriteria.AND;

export enum MetadataSubType1 {
	MATCH_ALL_WHOLE_WORDS = 0,
	MATCH_EXACTLY = 1,
	MATCH_ANY_WHOLE_WORDS = 2,
	EXCLUDE = 3,
	MATCH_ALL_WILD_CARDS = 4,
	MATCH_ANY_WILD_CARDS = 5,
	MATCH_ANY_RANGE = 6,
	NO_VALUE = 11,
	ANY_VALUE = 12,
}

export const NON_SORTABLE_SEARCH_TYPES = [SearchType.CUSTOM, SearchType.VISUAL];

export const SEARCH_SORT_SYSTEM_ATTRIBUTES = [
	ATTRIBUTE_SYSTEM_ID.checksum,
	ATTRIBUTE_SYSTEM_ID.expireDate,
	ATTRIBUTE_SYSTEM_ID.file,
	ATTRIBUTE_SYSTEM_ID.name,
	ATTRIBUTE_SYSTEM_ID.assetId,
	ATTRIBUTE_SYSTEM_ID.fileFormatFamily,
	ATTRIBUTE_SYSTEM_ID.fileSize2,
	ATTRIBUTE_SYSTEM_ID.filetypelabel,
	ATTRIBUTE_SYSTEM_ID.height,
	ATTRIBUTE_SYSTEM_ID.importDate,
	ATTRIBUTE_SYSTEM_ID.moddate,
	ATTRIBUTE_SYSTEM_ID.creationdate,
	ATTRIBUTE_SYSTEM_ID.dimensions,
	ATTRIBUTE_SYSTEM_ID['smart labels'],
	ATTRIBUTE_SYSTEM_ID.width,
	ATTRIBUTE_SYSTEM_ID.identifiedPeople,
];

export const FACETS_SUPPORT_SEARCH_TYPES = [
	SearchType.ACTIVE_TEMPLATES,
	SearchType.ADVANCED_RAW,
	SearchType.ATTRIBUTE_HISTORY,
	SearchType.CART,
	SearchType.CATEGORY_ID,
	SearchType.CATEGORY_NAME,
	SearchType.CHECKOUTS,
	SearchType.CONTENTS,
	SearchType.DATE,
	SearchType.FILE_ASPECT,
	SearchType.FILE_FORMAT,
	SearchType.FILE_FORMAT_FAMILY,
	SearchType.FILE_SIZE,
	SearchType.KEYWORD,
	SearchType.METADATA,
	SearchType.SAVED_SEARCH,
	SearchType.THESAURUS,
	SearchType.VISUAL,
];

export const SALO_STRING_MAP = <const>{
	a: 'sortField',
	b: 'sortOrder',
	c: 'matchCriteria',
	d: 'elementTypes',
	e: 'elementSubType1s',
	f: 'elementSubType2s',
	g: 'elementValue1s',
	h: 'elementValue2s',
	i: 'elementValue3s',
};
